import { Button } from "@progress/kendo-react-buttons";
import {
  GridColumnMenuItem,
  GridColumnMenuItemContent,
  GridColumnMenuItemGroup,
  GridColumnMenuProps
} from "@progress/kendo-react-grid";
import { useCallback, useMemo, useState } from "react";
import { Header } from "../../models/Header";

interface CustomColumnMenuProps extends GridColumnMenuProps {
  columns: Array<Header>;
  onColumnsSubmit: (event: any) => void;
}

export const CustomColumnMenu = (props: CustomColumnMenuProps) => {

  const [sortedColumns, setSortedColumns] = useState<Array<Header>>(
    props.columns.slice().sort((first: Header, second: Header) =>
      first.fieldLabel.localeCompare(second.fieldLabel)
    )
  );

  const onToggleColumn = useCallback((toggledColumn: Header) => {
    const nextSortedColumns = sortedColumns.map((column: Header) => {
      return toggledColumn.field === column.field
        ? { ...column, isDisplayed: !column.isDisplayed } as Header
        : column;
    });

    setSortedColumns(() => nextSortedColumns);
  }, [sortedColumns]);

  const onReset = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const nextSortedColumns: Array<Header> = props.columns.map((col: Header) => {
      return {
        ...col,
        isDisplayed: true,
      };
    });
    setSortedColumns(() => nextSortedColumns);
    props.onColumnsSubmit(nextSortedColumns);
    if (props.onCloseMenu) {
      props.onCloseMenu();
    }
  }, [props]);

  const onSubmit = useCallback((event: React.FormEvent<HTMLFormElement>) => {
    if (event) {
      event.preventDefault();
    }

    const tableOrderedColumns = props.columns.map(column => sortedColumns.find(listedColumn => listedColumn.field === column.field));

    props.onColumnsSubmit(tableOrderedColumns);

    if (props.onCloseMenu) {
      props.onCloseMenu();
    }
  }, [sortedColumns, props]);

  const oneVisibleColumn = useMemo(() =>
    sortedColumns.filter((column) => column.isDisplayed).length === 1
    , [sortedColumns]);

  return (
    <div data-component="custom-column-menu">
      <GridColumnMenuItemGroup>
        <GridColumnMenuItem
          title={"Colonnes"}
          iconClass="k-i-columns"
          onClick={() => { }}
        />
        <GridColumnMenuItemContent show={true}>
          <div className={"k-column-list-wrapper"}>
            <form onSubmit={onSubmit} onReset={onReset}>
              <div className={"k-column-list"}>
                {sortedColumns.map((column, index) => {
                  if (!column.field) {
                    return null;
                  }

                  return (
                    <div key={index} className={"k-column-list-item"}>
                      <span>
                        <input
                          id={`column-visiblity-show-${index}`}
                          className="k-checkbox k-checkbox-md k-rounded-md"
                          type="checkbox"
                          readOnly={true}
                          disabled={column.isDisplayed && oneVisibleColumn}
                          checked={column.isDisplayed}
                          onClick={() => {
                            onToggleColumn(column);
                          }}
                        />
                        <label
                          htmlFor={`column-visiblity-show-${index}`}
                          className="k-checkbox-label"
                          style={{ userSelect: "none" }}
                        >
                          {column.fieldLabel}
                        </label>
                      </span>
                    </div>
                  )
                })}
              </div>
              <div className={"k-actions k-hstack k-justify-content-stretch"}>
                <Button type="reset">Réinitialiser</Button>
                <Button themeColor={"primary"}>Appliquer</Button>
              </div>
            </form>
          </div>
        </GridColumnMenuItemContent>

      </GridColumnMenuItemGroup>
    </div>
  )
}
